export const STATUSADAPTER = {
	open: 'Abierta',
	close: 'Cerrada',
};
